import { Injectable } from '@angular/core';
import { ISystemConfiguration } from "../../configuration/interfaces/interfaces";
// The env service is used to get general environment information,
// not available from the web-api server.
/* tslint:disable */



declare var __ris_global_vars__:any;

interface IServerDetails{
	host:string;
	port:number;
	ssl:string;
	base:string;
}
@Injectable()
export class DeployedEnv {
	public auth:IServerDetails;
	public api:IServerDetails;
	public authSSO:IServerDetails;

	public baseResourcesUrl:string;
	public resourcesUrlWithVersion:string;

	public systemConfigurationDefaults: ISystemConfiguration;


	constructor() {
		if (window.location.hostname.indexOf("localhost")==-1 && __ris_global_vars__.singleEndPoint){
			this.resourcesUrlWithVersion = `${__ris_global_vars__.baseResourceUrl}` + (__ris_global_vars__.version ? `${__ris_global_vars__.version}/` : "");
			this.baseResourcesUrl = __ris_global_vars__.baseResourceUrl;
			this.api =this.getLocationDetails(__ris_global_vars__.apiServer.base);
			this.auth = this.getLocationDetails(__ris_global_vars__.authServer.base);
			this.authSSO = this.getLocationDetails( __ris_global_vars__.authServerApi.base);
		}else {
			this.resourcesUrlWithVersion = `${__ris_global_vars__.baseResourceUrl}` + (__ris_global_vars__.version ? `${__ris_global_vars__.version}/` : "");
			this.baseResourcesUrl = __ris_global_vars__.baseResourceUrl;
			this.api = __ris_global_vars__.apiServer;
			this.auth = __ris_global_vars__.authServer;
			this.authSSO = __ris_global_vars__.authServerApi;
		}

		this.systemConfigurationDefaults = __ris_global_vars__.systemConfigurationDefaults;
	}

	private getLocationDetails(base:string){
		var isSSL=window.location.protocol==="https:";
		return {
			host: window.location.hostname,
			port: window.location.port==""?(isSSL?443:80):+window.location.port,
			ssl: ""+isSSL,
			base:base
		}
	}
	// this function has to be static since it is accessed from components not accessible to DI (e.g. @Component dercorator)
	// public static removeBaseFromURL(url:string):string{
	// 	return url.substr( __ris_global_vars__.baseResourceUrl.length + 1);
	// }

	apiUrl() {
		return this.getUrl(this.api);
	}

	// wsUrl() {
	// 	return this.getUrl(this.api).substring(0,this.getUrl(this.api).indexOf("/api"))+"/signalr";
	// }

	confUrl() {
		return this.apiUrl();
	}

	authUrl() {
		return this.getUrl(this.auth);
	}

	authSSOUrl() {
		return this.getUrl(this.authSSO);
	}
	defaultSystemConfiguration() {
		return this.systemConfigurationDefaults;
	}

	public getUrl(server:IServerDetails) {//isSsl, ip, port, base
		let http:string;
		// due to ris installer limitations, the ssl setting in ris.globals must be a string (installer supports {$} patterns for
		// replacements which cannot be used in our javascript
		if (typeof(server.ssl) === "string" && server.ssl==="true") {
			http = "https";
		} else {
			http = "http";
		}
		return http + "://" + server.host + ":" + server.port + "/" + server.base;
	}

}
